<template style="display: flex">
  <v-container fluid class="px-0">
    <v-card>
      <v-card-title class="black white--text text-h5">
        <div>Project Directory</div>
      </v-card-title>
      <v-row class="pa-4" justify="space-between">
        <v-col cols="5">
          <v-treeview
            :active.sync="active_project"
            :items="project_tab_access_items"
            :load-children="get_project_tab_access"
            activatable
            open-on-click
            transition
          >
            <template v-slot:prepend="{ item }">
              <v-icon v-if="!item.children"> mdi-account </v-icon>
            </template>
          </v-treeview>
        </v-col>

        <v-divider vertical></v-divider>

        <v-col class="d-flex text-center">
          <v-scroll-y-transition mode="out-in">
            <div
              v-if="!selected_project_access"
              class="text-h6 grey--text text--lighten-1 font-weight-light"
              style="align-self: center"
            >
              Select a Project
            </div>
            <v-col v-else>
              <v-col cols="12" style="display: flex">
                <div style="flex: 3">
                  <v-card-title
                    class="black--text text-h6"
                    style="display: flex"
                  >
                    Set project tab access
                  </v-card-title>
                </div>
                <div>
                  <v-tooltip bottom v-if="disableAccessEdit">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="disableAccessEdit = !disableAccessEdit"
                      >
                        <v-icon color="black">mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <TooltipDescription
                      title="Enable project access edit"
                    ></TooltipDescription>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="disableAccessEdit = !disableAccessEdit"
                      >
                        <v-icon color="black">mdi-pencil-off-outline</v-icon>
                      </v-btn>
                    </template>
                    <TooltipDescription
                      title="Disable project access edit"
                    ></TooltipDescription>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="save_project_tab_access"
                        :disabled="disableAccessEdit"
                      >
                        <v-icon color="black">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <TooltipDescription
                      title="Save project access"
                    ></TooltipDescription>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="12" class="px-8">
                <v-checkbox
                  v-model="selected_project_access['MMM']"
                  label="MMM"
                  :disabled="disableAccessEdit"
                ></v-checkbox>
                <v-checkbox
                  v-model="selected_project_access['Audience']"
                  label="Audience"
                  :disabled="disableAccessEdit"
                ></v-checkbox>
                <v-checkbox
                  v-model="selected_project_access['ORT']"
                  label="ORT"
                  :disabled="disableAccessEdit"
                ></v-checkbox>
              </v-col>
            </v-col>
          </v-scroll-y-transition>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import admin_api_caller from "@/javascript/user_org_management";
import TooltipDescription from "@/components/Utility/TooltipDescription.vue";
import {
  ALERT_GENERIC_MESSAGE,
  ALERT_TYPE_ERROR,
  ALERT_TYPE_SUCCESS,
  SUCCESS_SAVE_PROJECT_ACCESS,
} from "@/constants/constants.js";
export default {
  name: "ProjectDirectory",
  props: [""],
  components: {
    TooltipDescription,
  },

  data: () => ({
    active_project: [],
    org_project_list: [],
    project_tab_access: {},
    disableAccessEdit: true,
  }),

  async mounted() {
    await this.get_project_tab_access();
  },

  computed: {
    project_tab_access_items() {
      return [
        {
          name: "Clients",
          children: this.org_project_list,
        },
      ];
    },
    selected_project_access() {
      if (!this.active_project.length) return undefined;

      const project_id = this.active_project[0];

      return this.project_tab_access[project_id]
        ? this.project_tab_access[project_id]
        : {
            MMM: false,
            Audience: false,
            ORT: false,
          };
    },
  },

  methods: {
    get_project_tab_access: async function () {
      let token = await this.$auth.getTokenSilently();

      const payload = { org_id: this.$auth.user.org_id };
      let result = await admin_api_caller
        .get_all_project_tab_access(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
      if (result) {
        this.org_project_list = result["org_projects"];
        this.project_tab_access = result["project_tab_access"];
      } else {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      }
    },
    save_project_tab_access: async function () {
      const project_id = this.active_project[0];

      let payload = {
        project_id: project_id,
        tab_access: {
          mmm: this.selected_project_access["MMM"],
          audience: this.selected_project_access["Audience"],
          ort: this.selected_project_access["ORT"],
        },
      };

      let token = await this.$auth.getTokenSilently();
      let result = await admin_api_caller
        .update_project_tab_access(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log(e);
          return false;
        });

      if (result) {
        this.$emit(
          "triggerAlert",
          ALERT_TYPE_SUCCESS,
          SUCCESS_SAVE_PROJECT_ACCESS
        );
        this.disableAccessEdit = true;
        await this.get_project_tab_access();
      } else {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      }

      return result;
    },
  },
};
</script>
<style>
.card-title {
  font-family: "Poppins" !important;
  font-weight: 800 !important;
  font-size: 1.2em !important;
}
.card-section-title {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 1.2em !important;
}
.card-action {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.9em !important;
}
</style>
